import { palette } from '@bumble/app/theme/palette';
import { lighten } from '@mui/material';
import { createTheme } from '@mui/material/styles';
import { COLORS } from './colors';

const theme = createTheme({ palette });
export const components = {
  MuiSwitch: {
    styleOverrides: {
      root: {
        padding: 8,
      },
      track: {
        borderRadius: 16,
      },
    },
  },
  MuiTableCell: {
    styleOverrides: {
      head: {
        fontWeight: 600,
      },
    },
  },
  MuiDataGrid: {
    styleOverrides: {
      columnHeaderTitle: {
        fontWeight: 600,
      },
    },
  },
  MuiTab: {
    styleOverrides: {
      root: {
        textTransform: 'none',
      },
    },
  },
  MuiButtonBase: {
    defaultProps: {
      disableRipple: true,
    },
  },
  MuiButton: {
    defaultProps: {
      disableElevation: true,
    },
    styleOverrides: {
      root: {
        borderRadius: 8,
        fullWidth: false,
        textTransform: 'none',
        borderColor: 'primary',
        lineHeight: 1,
        fontWeight: 700,
        letterSpacing: '0.015rem',
      },
      sizeSmall: {
        padding: '6px 12px',
      },
      sizeMedium: {
        padding: '8px 16px',
      },
      sizeLarge: {
        padding: '12px 24px',
      },
    },
  },
  MuiIconButton: {
    styleOverrides: {
      root: {
        borderRadius: '99px',
      },
      colorPrimary: {
        border: 'none',
        color: theme.palette.primary.main,
        transition: 'all 0.2s ease-in-out',
        '&:hover': {
          backgroundColor: lighten(COLORS.ACCENT, 0.25),
          color: theme.palette.primary.main,
        },
        '&:active': {
          backgroundColor: COLORS.ACCENT,
          color: theme.palette.primary.main,
        },
      },
      colorSecondary: {
        border: 'none',
        color: theme.palette.secondary.main,
        transition: 'all 0.2s ease-in-out',
        '&:hover': {
          backgroundColor: lighten(theme.palette.secondary.main, 0.8),
          color: theme.palette.secondary.main,
          borderColor: theme.palette.secondary.main,
        },
      },
    },
  },
  MuiOutlinedInput: {
    styleOverrides: {
      root: {
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: theme.palette.primary.main,
        },
      },
    },
  },
};
